const isFuelTypeExists = (fuelType, fuelTypeGroups) => {
    const allFuelTypes = fuelTypeGroups.map(ftg => {
        return ftg.fuelType
    })

    return allFuelTypes.includes(fuelType)
}

const groupByFuelType = (fuelType, genResData, otherGenerations) => {
    const grouped = []

    genResData.forEach(g => {
        const fuelTypeFound = g.fuelTypes.length === 0 ? 'OTHER' : g.fuelTypes[0]
        if (fuelTypeFound === fuelType) {
            grouped.push(g)
        }
    })

    if (typeof otherGenerations !== 'undefined' && otherGenerations !== null) {
        otherGenerations.forEach(g => {
            grouped.push(g)
        })
    }

    return grouped
}

const removeFuelTypeDuplicates = fuelTypeGroups => {
    return fuelTypeGroups.reduce((acc, current) => {
        const x = acc.find(item => item.fuelType === current.fuelType)
        if (!x) {
            return acc.concat([current])
        } else {
            return acc
        }
    }, [])
}

const collectFuelTypeGroups = genResData => {
    const extractOtherFuelTypeGeneration = fuelTypeGroups => {
        const otherFuelTypeGroups = fuelTypeGroups.filter(ftg => ftg.fuelType === 'OTHER')
        if (otherFuelTypeGroups.length > 0) {
            return groupByFuelType('OTHER', genResData)
        }
        return null
    }

    const duplicatedFuelTypeGroups = genResData.map(g => {
        return { fuelType: g.fuelTypes.length === 0 ? 'OTHER' : g.fuelTypes[0] }
    })
    const fuelTypeGroups = removeFuelTypeDuplicates(duplicatedFuelTypeGroups)
    const allGroups = []
    const otherGenerations = extractOtherFuelTypeGeneration(fuelTypeGroups)

    fuelTypeGroups.forEach(ftg => {
        if (ftg.fuelType !== 'OTHER') {
            allGroups.push(
                Object.assign(ftg, {
                    groupedGenerations: groupByFuelType(
                        ftg.fuelType,
                        genResData,
                        ftg.fuelType === 'PETROL' || ftg.fuelType === 'DIESEL' ? otherGenerations : null
                    )
                })
            )
        } else {
            ;['PETROL', 'DIESEL'].forEach(fuel => {
                if (!isFuelTypeExists(fuel, fuelTypeGroups)) {
                    allGroups.push({ fuelType: fuel, groupedGenerations: otherGenerations })
                }
            })
        }
    })

    return allGroups
}

export { collectFuelTypeGroups }
